export const LICENCE_AGREEMENT =
  'https://legal.8seats.com/end-user-license-agreement';
export const TERMS_OF_USE = 'https://legal.8seats.com/terms-of-use';
export const PRIVACY_POLICY = 'https://legal.8seats.com/privacy-policy';

export const DURATION_FOR_RESEND_SMS_VERIFICATION_CODE = 10000;

export const DATE_LOCALE = 'en-AU';
